import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { Subject, of } from 'rxjs';
import { distinctUntilChanged, debounceTime, skip, takeUntil } from 'rxjs/operators';

import { ApplicationService } from 'services/application/application.service';

@Component({
    selector: 'dialog-timeapprove-component',
    styleUrls: ['timeapprove.dialogcomponent.css'],
    templateUrl: 'timeapprove.dialogcomponent.html',
})
export class TimeApproveDialogComponent implements OnDestroy, OnInit {
    private _subrelease: Subject<void> = new Subject<void>();

    canceltext: string;
    duedate: Date;
    title: string;
    message: string;
    oktext: string;
    placeholderText: string;
    priority: number;
    note: string;
    noterequired: boolean;
    showIcon: boolean;

    constructor(
        public dialogRef: MatDialogRef<TimeApproveDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: BaseTimeApproveDialogOptions,
        private appSvc: ApplicationService
    ) {
        this.canceltext = data.CancelText || 'Cancel';
        this.oktext = data.OKText || 'OK';
        this.title = data.TitleText || 'Optional Note';
        this.message = data.MessageText || '';
        this.duedate = data.DueDate || null;
        this.note = data.Note || '';
        this.noterequired = data.NoteRequired != null ? data.NoteRequired : false;
        this.placeholderText = data.PlaceholderText || 'Enter text here...';
        this.priority = data.Priority || null;
        this.showIcon = data.ShowIcon != null ? data.ShowIcon : false;
    }

    ngOnDestroy() {
        this._subrelease.next();
        this._subrelease.complete();
    }

    ngOnInit() {
        const self = this;
    }

    OKHandler() {
        this.dialogRef.close(<BaseTimeApproveDialogResult>{
            Message: this.note,
            Priority: this.priority,
            DueDate: this.duedate,
        });
    }

    CancelHandler() {
        this.dialogRef.close(null);
    }

    // #region Is Valid Workday

    IsValidWorkday(d: Date) {
        const isValid = this.appSvc.IsValidWorkday(d);

        return isValid;
    }

    // #endregion

    // #region Update Priority

    UpdatePriority(value: number) {
        const self = this;

        // Update the bound variable
        self.priority = value;

        // Recalculate the due date based upon this change.
        let addedDays = 0;

        if (value === 4) {
            // Low priority. Wipe out the due date (if currently set)
            self.duedate = null;
            return;
        }

        switch (value) {
            case 1: // Urgent - 24 hours
                addedDays = 1;
                break;
            case 2: // High - 2 days
                addedDays = 2;
                break;
            case 3: // Routine - 5 days
                addedDays = 5;
                break;
        }

        if (addedDays > 0) {
            // Get the new due date
            const dueDate = self.appSvc.GetDueDate(addedDays);

            // Set the due date now
            self.duedate = dueDate;
        }
    }

    // #endregion
}

// #region Custom Classes

// #region Base Time Approve Dialog Options Class

export class BaseTimeApproveDialogOptions {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    IconColor?: string;
    IconName?: string;
    ShowIcon?: boolean;
    height?: string;
    width?: string;
    DueDate?: Date;
    Note?: string;
    PlaceholderText?: string;
    Priority?: number;
    NoteRequired?: boolean;
}

// #endregion

// #region Base Time Approve Dialog Result Class

export class BaseTimeApproveDialogResult {
    Message?: string;
    Priority?: number;
    DueDate?: Date;
}

// #endregion

// #endregion
